/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-empty-function */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { IconService } from '@isophi/core-ui';
import {NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import {CustomDateParserFormatter} from "@app/shared/components/date-input/custom-date-parser-formatter";

@Component({
    selector: 'app-date-input',
    templateUrl: './date-input.component.html',
    styleUrls: ['./date-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateInputComponent),
            multi: true,
        },
        {
            provide: NgbDateParserFormatter,
            useClass: CustomDateParserFormatter,
        }
    ],
    standalone: false
})
export class DateInputComponent implements ControlValueAccessor {
  @Input() form: FormGroup;

  @Input() formControlName: string;

  @Input() label: string;

  @Input() required? = false;

  @Input() requiredColor? = false;

  @Input() parentVisible? = false;

  @Input() formControlError?: string;

  @Input() placeholder?: string = '';

  @Input()
  minDate: NgbDateStruct = undefined;

  @Input()
  maxDate: NgbDateStruct = undefined;

  constructor(protected iconService: IconService, private cd: ChangeDetectorRef) {}

  onChange: any = () => {};

  onTouched: any = () => {};

  getFormControl(): FormControl {
    return this.form.get(this.formControlName) as FormControl;
  }

  writeValue(value: any): void {
    this.onChange(value);
    this.cd.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
